import select2 from 'select2'
import 'select2/dist/css/select2.css'

export default class FormFieldsComponent {
    constructor() {
        this.select2init()
    }

    static #selectSelector = '.select2-select select'
    static #selectSelectorWithSearchBar = '.select2-select.has-search-bar select '

    select2init() {
        $(FormFieldsComponent.#selectSelector).select2({
            minimumResultsForSearch: -1,
            language: {
                noResults: () => 'Aucun résultat',
            },
        })

        $(FormFieldsComponent.#selectSelectorWithSearchBar).select2({
            minimumResultsForSearch: 10,
            language: {
                noResults: () => 'Aucun résultat',
            },
        })
    }
}
